import styled from 'styled-components';

/* The same row as Settings, Integrations and the activity log beside it — one type size, one grey,
   one padding. What makes it a setting rather than a destination is the switch at the end, so it
   takes the full width the others do not need. */
export const Row = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 8px;
  border: none;
  border-radius: 10px;
  background: transparent;
  color: var(--mantine-color-text);
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  text-align: left;
  cursor: pointer;

  .label {
    flex: 1;
  }

  &:hover {
    background: var(--mantine-color-default-hover);
  }
`;
